module.exports = __webpack_public_path__ + "img/26-800x800.5c11a522.jpg";